<template>
  <div :class="['section', { 'section--no-border no-padding-bottom': borderless }]">
    <div :class="['flex space-between align-center gap', { spacing: !borderless }]">
      <h1 class="title title--2 grow no-spacing">
        {{ title }}
      </h1>

      <slot>
        <router-link
          class="button button--light button--primary button--small button--auto-width no-spacing"
          :to="{
            name: 'orderMenu',
            params: {
              merchantId: $route.params.merchantId
            }
          }"
        >
          Browse Menu
        </router-link>
      </slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'PageHeader',

    props: {
      borderless: {
        type: Boolean,
        default: false
      },

      title: {
        type: String,
        required: true
      }
    }
  };
</script>
